import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import Modal from "react-modal";
import { toast } from "react-toastify";
import Afterloginheader from "../../components/MainHeader/Afterloginheader";
import {
  addPatientMemberApi,
  cityListApi,
  createAppointmentApi,
  createTimelineCard,
  dateAvailabilityApi,
  getAppointmentBookingStep1,
  getQuestionApi,
} from "../../services/apiService";
import Skeleton from "react-loading-skeleton";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { format } from "date-fns";
import { useUserContext } from "../../context/UserContext";
import cancelIcon from "../../assets/images/cancel-btn.svg";

import docimg from "../../assets/images/DocImg.png";
import CrossIcon from "../../assets/images/CrossIcon.svg";
import StarIcon from "../../assets/images/StarIcon.svg";
import VideoIcon from "../../assets/images/VideoIcon.svg";
import CabinetIcon from "../../assets/images/CabinetIcon.svg";
import UserIcon from "../../assets/images/User_Icon.svg";
import CalanderIcon from "../../assets/images/CalanderIcon.svg";
import LocIcon from "../../assets/images/LocationIcon.svg";
import StethIcon from "../../assets/images/StethoscopeIcon.svg";
import NoImage from "../../assets/images/no-image-avatar.png";
import { DEFAULT_PROFILE_IMAGE, IMAGE_URL } from "../../app_url";
import moment from "moment";

import { useCities } from "@/queries/useLocalisationQuery"

Modal.setAppElement("#root");

const BookAppointment = () => {
  const { userData, searchValuesContext } = useUserContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedStep, setSelectedStep] = useState(0);
  const [choosePatient, setChoosePatient] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [alreadyVisit, setAlreadyVisit] = useState("yes");
  const [allDetails, setAllDetails] = useState();
  const [patientForm, setPatientForm] = useState({ name: "", age: "", relation: "" });
  const [addBtnDis, setAddBtnDis] = useState(false);
  const [screenLoading, setScreenLoading] = useState(false);
  const [chooseReason, setChooseReason] = useState("");
  const [consultType, setConsultType] = useState("");
  const [doctorSavedCunsultType, setDoctorSavedCunsultType] = useState("0");
  const [date, setDate] = useState(new Date());
  const [availDates, setAvailDates] = useState();
  const [selectedTime, setSelectedTime] = useState();
  const [appTimeDateAlreadySelected, setAppTimeDateAlreadySelected] = useState(false);
  const [questionDetails, setQuestionDetails] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [futureDate, setFutureDate] = useState();
  const [bookedAppoinment, setBookedAppoinment] = useState();
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [addPatientObject, setAddPatientObject] = useState({});

  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);

  const daysarray = [];
  for (let i = 1; i <= 31; i++) {
    daysarray.push(i < 10 ? "0" + i : i);
  }

  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 100;
  const years = [];

  for (let year = startYear; year <= currentYear; year++) {
    years.push(year);
  }

  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const handlePatientMemberChange = event => {
    setChoosePatient(parseInt(event.target.value));
  };

  const handleAlreadyVisitChange = event => {
    setAlreadyVisit(event.target.value);
  };

  const handleReasonChange = event => {
    setChooseReason(parseInt(event.target.value));
  };

  const handleConsultTypeChange = event => {
    setConsultType(event.target.value);
  };

  const handleChooseResCont = () => {
    if (!chooseReason) {
      toast.warning("Please choose a reason to continue.", { autoClose: 1500 });
    } else {
      setSelectedStep(4);
    }
  };

  const handleChooseConsultCont = async () => {
    if (!consultType) {
      toast.warning("Please choose a consultation type to continue.", { autoClose: 1500 });
    } else {
      if (appTimeDateAlreadySelected) {
        setSelectedStep(questionDetails?.length + 3);
      } else {
        setSelectedStep(questionDetails?.length + 2);
      }

      let tempconsultType = consultType === "Video" ? "For online consultation" : consultType === "Cabinet" ? "For cabinet consultation " : "";
      getDateAvailabilityList(searchValuesContext?.user_id, format(date, "yyyy-MM-dd"), tempconsultType);
    }
  };

  const handleChooseTimeCont = async () => {
    if (!selectedTime) {
      toast.warning("Please choose a timing for your appointment.", { autoClose: 1500 });
    } else {
      setSelectedStep(questionDetails?.length + 3);
    }
  };

  const handleDateChange = newDate => {
    setDate(newDate);
    let tempconsultType = consultType === "Video" ? "For online consultation" : consultType === "Cabinet" ? "For cabinet consultation " : "";
    setSelectedTime(null);
    getDateAvailabilityList(searchValuesContext?.user_id, format(newDate, "yyyy-MM-dd"), tempconsultType);
  };

  const getPatientList = async docId => {
    if (docId) {
      setScreenLoading(true);
      try {

        let response = await getAppointmentBookingStep1({
          doctor_id: docId
        });
        if (response) {
          if (response.data.res === true) {
            setAllDetails(response.data);
            if (response.data.data.length > 0) {
              setChoosePatient(response.data.data[0].user_id);
              console.log(response.data.doctor.consultation_type)
              setDoctorSavedCunsultType(response.data.doctor.consultation_type ? response.data.doctor.consultation_type.toString() : "0");
              // setDoctorSavedCunsultType("1");
            } else {
              setChoosePatient(null);
              setDoctorSavedCunsultType("0");
            }
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }
        setScreenLoading(false);
      } catch (error) {
        setScreenLoading(false);
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
      }
    }
  };

  const getQuestionList = async docId => {
    if (docId) {
      try {
        let formData = new FormData();
        formData.append("doctor_id", docId);

        let response = await getQuestionApi(formData);
        if (response) {
          if (response.data.res === true) {
            setQuestionDetails(response.data.data);
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
      }
    }
  };

  const getDateAvailabilityList = async (docId, date, consultationType) => {
    if (docId && date && consultationType) {
      setScreenLoading(true);
      try {
        let formData = new FormData();
        formData.append("doctor_id", docId);
        formData.append("date", date);
        formData.append("consultation_types", consultationType);

        let response = await dateAvailabilityApi(formData);
        if (response) {
          if (response.data.res === true) {
            // const notAvailableSet = new Set(response.data.notAvailable.map(({time}) => time));
            // const tempArray = response.data.data.filter(item => !notAvailableSet.has(item));
            const tempFormatHoliday = response.data.holiday ? response.data.holiday.map(item => item.holiday_date) : [];
            if (tempFormatHoliday.includes(date)) {
              setAvailDates([]);
            } else {
              setAvailDates(response.data.data);
            }
            setBookedAppoinment(response.data.notAvailable.map(({ time }) => time));

            const tempFutureDate = moment().add(parseInt(response.data.future_days, 10), "days");
            setFutureDate(tempFutureDate);
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }
        setScreenLoading(false);
      } catch (error) {
        setScreenLoading(false);
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
      }
    }
  };

  const handleAddPatient = async () => {
    if (!patientForm.name) {
      toast.warning("Please enter name.", { autoClose: 1500 });
    } else if (!patientForm.age) {
      toast.warning("Please enter age.", { autoClose: 1500 });
    } else if (!patientForm.relation) {
      toast.warning("Please enter relation.", { autoClose: 1500 });
    } else {
      setAddBtnDis(true);
      try {
        let formData = new FormData();
        formData.append("name", patientForm.name);
        formData.append("age", patientForm.age);
        formData.append("relation", patientForm.relation);

        let response = await addPatientMemberApi(formData);
        if (response) {
          if (response.data.res === true) {
            closeModal();
            setPatientForm({ name: "", age: "", relation: "" });
            getPatientList(searchValuesContext?.user_id);
            toast.success(response.data.msg ? response.data.msg : "Member added successfully", { autoClose: 1500 });
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }
        setAddBtnDis(false);
      } catch (error) {
        setAddBtnDis(false);
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
      }
    }
  };

  const handleSelectTime = time => {
    if (time.has_interval === 1) {
      let title = time?.start_time + "-" + time?.end_time;
      let count = 0;
      bookedAppoinment.forEach(element => {
        if (element === title) {
          count += 1;
        }
      });

      if (count >= time?.visitor) {
        toast.warning("Oops! This time slot is full. Please try on different time.", { autoClose: 1500 });
        setSelectedTime(null);
      } else {
        setSelectedTime(title);
      }
    } else {
      if (bookedAppoinment.includes(time)) {
        toast.warning("Oops! This time slot is already taken. Please choose a different slot.", { autoClose: 1500 });
        setSelectedTime(null);
      } else {
        setSelectedTime(time);
      }
    }
  };

  const handleConfirmAppointment = async () => {
    if (choosePatient && date && consultType && selectedTime) {
      setAddBtnDis(true);
      try {
        let formData = new FormData();
        formData.append("doctor_id", searchValuesContext?.user_id);
        formData.append("patient_id", choosePatient);
        formData.append("appointment_date", format(date, "yyyy-MM-dd"));
        formData.append(
          "consultation_type",
          consultType === "Video" ? "For online consultation" : consultType === "Cabinet" ? "For cabinet consultation " : ""
        );
        formData.append("time", selectedTime?.has_interval === 1 ? selectedTime?.start_time + "-" + selectedTime?.end_time : selectedTime);

        answers.map((item, index) => {
          if (item.skipped !== 1) {
            formData.append(`options[${index}][question_id]`, item?.questId);
            formData.append(`options[${index}][options_id]`, item?.optionId);
            formData.append(`options[${index}][options_value]`, item?.value);
          }
        });

        let response = await createAppointmentApi(formData);

        if (response) {
          if (response.data.res === true) {
            // --- Création de la timeline card ---
            try {
              await createTimelineCard(searchValuesContext?.user_id, {
                label: "Consultation",  // titre de la carte
                color: "#16A34A"        // couleur verte
              });
            } catch (cardError) {
              console.error("Erreur création carte timeline:", cardError);
              toast.error("Timeline card could not be created.", { autoClose: 1500 });
            }

            navigate("/appointment-booking/confirm", {
              state: {
                time: selectedTime,
                date: format(date, "EEEE, MMMM d, yyyy"),
                doctorDetails: allDetails?.doctor
              },
            });

            toast.success(response.data.msg ? response.data.msg : "Appointment booked successfully.", { autoClose: 1500 });
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }

        setAddBtnDis(false);
      } catch (error) {
        setAddBtnDis(false);
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
      }
    } else {
      toast.error("Something went wrong. Please try again.", { autoClose: 1500 });
    }
  };


  const handleOptionChange = (stepIndex, question, questId, value, optionId) => {
    if (stepIndex && questId && value && optionId) {
      let newAnswers = [...answers];
      const existingIndex = newAnswers.findIndex(answer => answer?.questId === questId);
      const newAnswer = { questId, question, value, optionId, skipped: 0 };

      if (existingIndex !== -1) {
        // If the questId already exists, update the existing answer
        newAnswers[existingIndex] = newAnswer;
      } else {
        // Otherwise, add the new answer
        newAnswers[stepIndex] = newAnswer;
      }

      const filteredAnswers = newAnswers.filter(answer => answer !== undefined && Object.keys(answer).length > 0);
      setAnswers(filteredAnswers);
    }
  };

  const canContinue = () => {
    // console.log(answers[selectedStep - 1]);
    return answers[selectedStep - 1] !== undefined && answers[selectedStep - 1] !== null;
  };

  useEffect(() => {
    console.log(selectedStep)
  }, [selectedStep])

  const renderStepContent = stepIndex => {
    const currentQuestion = questionDetails[stepIndex - 1];
    return (
      <div className="ContainerPnl">
        <div className="ColPnl-8">
          <div className="LftBox">
            {stepIndex > 0 && (
              <button className="PrevBtn" onClick={() => setSelectedStep(stepIndex - 1)}>
                Go to back previous step{selectedStep}
              </button>
            )}
            <h2>{currentQuestion?.question}</h2>
            <ul className="PatientList AlreadyVisit">
              {currentQuestion?.options.map(option => (
                <li key={option.id} onClick={() => handleOptionChange(stepIndex, currentQuestion?.question, currentQuestion?.id, option.options, option?.id)}>
                  <span className="PatientName">
                    <span className="NameWrapper">{option.options}</span>
                  </span>
                  <span className="SelectOption">
                    <input type="radio" value={option.options.toLowerCase()} checked={answers[stepIndex - 1]?.value === option.options} onChange={() => { }} />
                  </span>
                </li>
              ))}
            </ul>
            {questionDetails[0]?.no === 1 && answers.find(item => item?.questId === questionDetails[0]?.id)?.value === "No" ? (
              <button
                className="CmnBtn"
                onClick={() => toast.warning("Sorry! You can't book an appointment with this doctor right now. Please check back later.", { autoClose: 1500 })}>
                Continue
              </button>
            ) : (
              <p>
                <button
                  className="CmnBtn"
                  onClick={() => {
                    if (canContinue()) {
                      let tempAnsw = [...answers];
                      console.log(tempAnsw);
                      tempAnsw[stepIndex - 1].skipped = 0;
                      setAnswers(tempAnsw);

                      setSelectedStep(stepIndex + 1);
                      if (doctorSavedCunsultType === "1") {
                        //setSelectedStep(stepIndex + 1);
                      } else {//console.log(doctorSavedCunsultType);
                        //setSelectedStep(stepIndex + 2);
                        setConsultType("Cabinet");
                      }
                    } else {
                      toast.warning("Please select an option before continuing.", { autoClose: 1500 });
                    }
                  }}>
                  Continue
                </button>
                {currentQuestion?.ask === 0 ? (
                  <button
                    className="CmnBtn skipBtn"
                    onClick={() => {
                      let tempAnsw = [...answers];
                      if (tempAnsw[stepIndex - 1]) {
                        tempAnsw[stepIndex - 1].skipped = 1;
                        setAnswers(tempAnsw);
                      }
                      setSelectedStep(stepIndex + 1);
                      setChooseReason(null);
                    }}>
                    Skip
                  </button>
                ) : null}
              </p>
            )}
          </div>
        </div>
        <div className="ColPnl-4">
          <div className="RhtBox">
            <ul className="SearchedDoctors">
              <li>
                <div className="DocImg">
                  <img src={allDetails?.doctor?.profile_pic_url ? allDetails?.doctor?.profile_pic_url : DEFAULT_PROFILE_IMAGE} alt="" />
                </div>
                <div className="DocDtls">
                  <span className="DocName">
                    {allDetails?.doctor?.first_name} {allDetails?.doctor?.last_name}
                  </span>
                  <span className="DocType">{allDetails?.doctor?.speciality}</span>
                  <span className="DocRating">
                    <img src={StarIcon} alt="" /> {allDetails?.averageRating}
                  </span>
                </div>
              </li>
            </ul>
            <div className="AppoDetails">
              <h5>Your appointment in detail</h5>
              <ul>
                {appTimeDateAlreadySelected && (
                  <li>
                    {format(date, "MMMM d")} {selectedTime}
                  </li>
                )}
                <li>Choose the patient name</li>
                {answers?.map((item, index) => (item?.skipped !== 1 ? <li key={index}>{item?.question}?</li> : null))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const generateTimeSlots = (startTime, endTime, interval, timeSlotType) => {
    const slots = [];

    // Create moment objects for the start and end times
    const startMoment = moment(startTime, "HH:mm");
    const endMoment = moment(endTime, "HH:mm");

    // Loop to generate time slots
    while (startMoment.isBefore(endMoment)) {
      slots.push(startMoment.format("HH:mm")); // Format as HH:mm
      if (timeSlotType === "Minute") {
        startMoment.add(interval, "minutes"); // Increment by the interval in minutes
      } else if (timeSlotType === "Hour") {
        startMoment.add(interval, "hours"); // Increment by the interval in hours
      }
    }

    // Remove the last slot if it equals the end time
    if (slots[slots.length - 1] === endMoment.format("HH:mm")) {
      slots.pop();
    }
    return slots;
  };

  const { data: cityList } = useCities()

  const handleAddKid = async () => {
    if (!addPatientObject?.gender) {
      toast.warning("Please select gender.", { autoClose: 1500 });
    } else if (!addPatientObject?.firstName) {
      toast.warning("Please enter first name.", { autoClose: 1500 });
    } else if (/[\u0600-\u06FF]/.test(addPatientObject.firstName)) {
      toast.warning("First name cannot contain Arabic characters.", { autoClose: 1500 });
    } else if (!addPatientObject?.lastName) {
      toast.warning("Please enter last name.", { autoClose: 1500 });
    } else if (/[\u0600-\u06FF]/.test(addPatientObject.lastName)) {
      toast.warning("Last name cannot contain Arabic characters.", { autoClose: 1500 });
    } else if (!addPatientObject?.month) {
      toast.warning("Please select month.", { autoClose: 1500 });
    } else if (!addPatientObject?.day) {
      toast.warning("Please select day.", { autoClose: 1500 });
    } else if (!addPatientObject?.year) {
      toast.warning("Please select year.", { autoClose: 1500 });
    } else if (!addPatientObject?.birthCity) {
      toast.warning("Please select birth city.", { autoClose: 1500 });
    } else if (addPatientObject.membertype === "child" && !addPatientObject?.relation) {
      toast.warning("Please select relation.", { autoClose: 1500 });
    } else {
      setAddBtnDis(true);
      try {
        let formData = new FormData();
        formData.append("gender", addPatientObject.gender);
        formData.append("first_name", addPatientObject.firstName);
        formData.append("last_name", addPatientObject.lastName);
        formData.append("relation", addPatientObject.relation || "");
        formData.append("month", addPatientObject.month);
        formData.append("day", addPatientObject.day);
        formData.append("year", addPatientObject.year);
        formData.append("birth_city_id", addPatientObject.birthCity);
        formData.append("member_type", addPatientObject.membertype);

        let response = await addPatientMemberApi(formData);
        if (response) {
          if (response.data.res === true) {
            setShowProfileModal(false);
            setAddPatientObject({});
            getPatientList(searchValuesContext?.user_id);
            toast.success(response.data.msg ? response.data.msg : "Member added successfully", { autoClose: 1500 });
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }
        setAddBtnDis(false);
      } catch (error) {
        setAddBtnDis(false);
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
      }
    }
  };

  useEffect(() => {
    getPatientList(searchValuesContext?.user_id);
    getQuestionList(searchValuesContext?.user_id);
    getCityList();
    if (searchValuesContext?.selectedAppDate && searchValuesContext?.selectedAppTime) {
      setDate(new Date(searchValuesContext?.selectedAppDate));
      setSelectedTime(searchValuesContext?.selectedAppTime);
      setAppTimeDateAlreadySelected(true);
    } else {
      setAppTimeDateAlreadySelected(false);
    }
  }, []);

  const getBookedCount = (timeSlot) => {
    let count = 0;
    bookedAppoinment.forEach(element => {
      if (element === timeSlot) {
        count += 1;
      }
    });
    return count;
  };

  return (
    <div className="Main">
      <Afterloginheader />

      <div className="BookAppWrapper">
        <div className="HeadingBar">
          <div className="ContainerPnl">
            <div className="ColPnl-12">
              <h3>Book your appointment</h3>
              <p>Fill in the following information</p>
            </div>
          </div>
        </div>
        {selectedStep === 0 ? (
          <div className="ContainerPnl">
            <div className="ColPnl-8">
              <div className="LftBox">
                <button
                  className="PrevBtn"
                  onClick={() => {
                    location?.state?.from ? navigate(location?.state?.from) : navigate("/");
                  }}>
                  Go to back previous step
                </button>
                <h2>Choose the patient name</h2>
                <ul className="PatientList">
                  {screenLoading ? (
                    <div className="Card">
                      <Skeleton count={1} height={40} width={"80%"} baseColor="#cfd5f9" />
                      <br />
                      <p>
                        <Skeleton count={1} height={40} width={"80%"} baseColor="#cfd5f9" />
                      </p>
                    </div>
                  ) : allDetails?.data?.length > 0 ? (
                    allDetails?.data?.map((item, index) => (
                      <li key={index} onClick={() => setChoosePatient(parseInt(item?.user_id))}>
                        <span className="PatientName">
                          <span className={userData?.users?.id === item?.user_id ? "PatientShortName" : "PatientShortName OtherMember"}>{item?.initials}</span>
                          <span className="NameWrapper">
                            {item?.first_name} {item?.last_name}
                            {userData?.users?.id !== item?.user_id ? (
                              <span className="OtherMember">{item?.relation !== "undefined" ? item?.relation : ""}</span>
                            ) : null}
                          </span>
                        </span>
                        <span className="SelectOption">
                          <input type="radio" value={item?.user_id} checked={choosePatient === parseInt(item?.user_id)} onChange={handlePatientMemberChange} />
                        </span>
                      </li>
                    ))
                  ) : null}
                </ul>
                {!screenLoading ? (
                  <>
                    <button
                      style={{
                        width: 'auto',
                        height: 'auto',
                        'padding': '1rem'
                      }}
                      type="button" className="IconBtn" onClick={() => setShowProfileModal(true)}>
                      Add new member
                    </button>
                    <p>
                      <button className="CmnBtn" onClick={() => setSelectedStep(1)}>
                        Continue
                      </button>
                    </p>
                  </>
                ) : null}
              </div>
            </div>
            <div className="ColPnl-4">
              <div className="RhtBox">
                <ul className="SearchedDoctors">
                  <li>
                    <div className="DocImg">
                      <img src={allDetails?.doctor?.profile_pic_url ? allDetails?.doctor?.profile_pic_url : DEFAULT_PROFILE_IMAGE} alt="" />
                    </div>
                    <div className="DocDtls">
                      <span className="DocName">
                        {allDetails?.doctor?.first_name} {allDetails?.doctor?.last_name}
                      </span>
                      <span className="DocType">{allDetails?.doctor?.speciality}</span>
                      <span className="DocRating">
                        <img src={StarIcon} alt="" /> {allDetails?.averageRating}
                      </span>
                    </div>
                  </li>
                </ul>
                <div className="AppoDetails">
                  <h5>Your appointment in detail</h5>
                  <ul>
                    {appTimeDateAlreadySelected && (
                      <li>
                        {format(date, "MMMM d")} {selectedTime}
                      </li>
                    )}
                    <li>Choose the patient name</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {selectedStep > 0 && selectedStep < questionDetails?.length + 1 && renderStepContent(selectedStep)}

        {/* {selectedStep === 2 ? (
          <div className="ContainerPnl">
            <div className="ColPnl-8">
              <div className="LftBox">
                <button className="PrevBtn" onClick={() => setSelectedStep(1)}>
                  Go to back previous step
                </button>
                <h2>Did you already visit this doctor ?</h2>
                <ul className="PatientList AlreadyVisit">
                  <li onClick={() => setAlreadyVisit("yes")}>
                    <span className="PatientName">
                      <span className="NameWrapper">Yes</span>
                    </span>
                    <span className="SelectOption">
                      <input type="radio" value="yes" checked={alreadyVisit === "yes"} onChange={handleAlreadyVisitChange} />
                    </span>
                  </li>
                  <li onClick={() => setAlreadyVisit("no")}>
                    <span className="PatientName">
                      <span className="NameWrapper">No</span>
                    </span>
                    <span className="SelectOption">
                      <input type="radio" value="no" checked={alreadyVisit === "no"} onChange={handleAlreadyVisitChange} />
                    </span>
                  </li>
                </ul>
                <p>
                  <button className="CmnBtn" onClick={() => setSelectedStep(3)}>
                    Continue
                  </button>
                </p>
              </div>
            </div>
            <div className="ColPnl-4">
              <div className="RhtBox">
                <ul className="SearchedDoctors">
                  <li>
                    <div className="DocImg">
                      <img src={allDetails?.doctor?.profile_pic ? IMAGE_URL + allDetails?.doctor?.profile_pic : NoImage} alt="" />
                    </div>
                    <div className="DocDtls">
                      <span className="DocName">
                        {allDetails?.doctor?.first_name} {allDetails?.doctor?.last_name}
                      </span>
                      <span className="DocType">{allDetails?.doctor?.speciality}</span>
                      <span className="DocRating">
                        <img src={StarIcon} alt="" /> 4.5
                      </span>
                    </div>
                  </li>
                </ul>
                <div className="AppoDetails">
                  <h5>Your appointment in detail</h5>
                  <ul>
                    {appTimeDateAlreadySelected && (
                      <li>
                        {format(date, "MMMM d")} {selectedTime}
                      </li>
                    )}
                    <li>Choose the patient name</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {selectedStep === 3 ? (
          <div className="ContainerPnl">
            <div className="ColPnl-8">
              <div className="LftBox">
                <button className="PrevBtn" onClick={() => setSelectedStep(2)}>
                  Go to back previous step
                </button>
                <h2>What is the reason of the consultation?</h2>
                <ul className="PatientList AlreadyVisit">
                  {allDetails?.consultationReason?.map((item, index) => (
                    <li key={index} onClick={() => setChooseReason(parseInt(item?.id))}>
                      <span className="PatientName">
                        <span className="NameWrapper">{item?.name}</span>
                      </span>
                      <span className="SelectOption">
                        <input type="radio" value={item?.id} checked={chooseReason === parseInt(item?.id)} onChange={handleReasonChange} />
                      </span>
                    </li>
                  ))}
                </ul>
                <p>
                  <button className="CmnBtn" onClick={() => handleChooseResCont()}>
                    Continue
                  </button>{" "}
                  <button
                    className="CmnBtn skipBtn"
                    onClick={() => {
                      setSelectedStep(4);
                      setChooseReason(null);
                    }}>
                    Skip
                  </button>
                </p>
              </div>
            </div>
            <div className="ColPnl-4">
              <div className="RhtBox">
                <ul className="SearchedDoctors">
                  <li>
                    <div className="DocImg">
                      <img src={allDetails?.doctor?.profile_pic ? IMAGE_URL + allDetails?.doctor?.profile_pic : NoImage} alt="" />
                    </div>
                    <div className="DocDtls">
                      <span className="DocName">
                        {allDetails?.doctor?.first_name} {allDetails?.doctor?.last_name}
                      </span>
                      <span className="DocType">{allDetails?.doctor?.speciality}</span>
                      <span className="DocRating">
                        <img src={StarIcon} alt="" /> 4.5
                      </span>
                    </div>
                  </li>
                </ul>
                <div className="AppoDetails">
                  <h5>Your appointment in detail</h5>
                  <ul>
                    {appTimeDateAlreadySelected && (
                      <li>
                        {format(date, "MMMM d")} {selectedTime}
                      </li>
                    )}
                    <li>Choose the patient name</li>
                    <li>Did you already visit this doctor?</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ) : null} */}

        {selectedStep === questionDetails?.length + 1 ? (
          <div className="ContainerPnl">
            <div className="ColPnl-8">
              <div className="LftBox">
                <button className="PrevBtn" onClick={() => setSelectedStep(questionDetails?.length)}>
                  Go to back previous step
                </button>
                <h2>Did you want to consultation via video or cabinet?</h2>
                <ul className="PatientList ConsultOption">
                  {doctorSavedCunsultType === "1" ? (
                    <li onClick={() => setConsultType("Video")}>
                      <span className="PatientName">
                        <img src={VideoIcon} alt="" />
                        <span className="NameWrapper">Video consultation</span>
                      </span>
                      <span className="SelectOption">
                        <input type="radio" value="Video" checked={consultType === "Video"} onChange={handleConsultTypeChange} />
                      </span>
                    </li>
                  ) : null}

                  <li onClick={() => setConsultType("Cabinet")}>
                    <span className="PatientName">
                      <img src={CabinetIcon} alt="" />
                      <span className="NameWrapper">Cabinet consultation</span>
                    </span>
                    <span className="SelectOption">
                      <input type="radio" value="Cabinet" checked={consultType === "Cabinet"} onChange={handleConsultTypeChange} />
                    </span>
                  </li>
                  {/* {doctorSavedCunsultType === "0" ? (
                    <>
                      <li onClick={() => setConsultType("Video")}>
                        <span className="PatientName">
                          <img src={VideoIcon} alt="" />
                          <span className="NameWrapper">Video consultation</span>
                        </span>
                        <span className="SelectOption">
                          <input type="radio" value="Video" checked={consultType === "Video"} onChange={handleConsultTypeChange} />
                        </span>
                      </li>
                      <li onClick={() => setConsultType("Cabinet")}>
                        <span className="PatientName">
                          <img src={CabinetIcon} alt="" />
                          <span className="NameWrapper">Cabinet consultation</span>
                        </span>
                        <span className="SelectOption">
                          <input type="radio" value="Cabinet" checked={consultType === "Cabinet"} onChange={handleConsultTypeChange} />
                        </span>
                      </li>
                    </>
                  ) : doctorSavedCunsultType === "1" ? (
                    <>
                      <li onClick={() => setConsultType("Video")}>
                        <span className="PatientName">
                          <img src={VideoIcon} alt="" />
                          <span className="NameWrapper">Video consultation</span>
                        </span>
                        <span className="SelectOption">
                          <input type="radio" value="Video" checked={consultType === "Video"} onChange={handleConsultTypeChange} />
                        </span>
                      </li>
                    </>
                  ) : doctorSavedCunsultType === "2" ? (
                    <>
                      <li onClick={() => setConsultType("Cabinet")}>
                        <span className="PatientName">
                          <img src={CabinetIcon} alt="" />
                          <span className="NameWrapper">Cabinet consultation</span>
                        </span>
                        <span className="SelectOption">
                          <input type="radio" value="Cabinet" checked={consultType === "Cabinet"} onChange={handleConsultTypeChange} />
                        </span>
                      </li>
                    </>
                  ) : null} */}
                </ul>
                <p>
                  <button className="CmnBtn" onClick={() => handleChooseConsultCont()}>
                    Continue
                  </button>
                </p>
              </div>
            </div>
            <div className="ColPnl-4">
              <div className="RhtBox">
                <ul className="SearchedDoctors">
                  <li>
                    <div className="DocImg">
                      <img src={allDetails?.doctor?.profile_pic_url ? allDetails?.doctor?.profile_pic_url : DEFAULT_PROFILE_IMAGE} alt="" />
                    </div>
                    <div className="DocDtls">
                      <span className="DocName">
                        {allDetails?.doctor?.first_name} {allDetails?.doctor?.last_name}
                      </span>
                      <span className="DocType">{allDetails?.doctor?.speciality}</span>
                      <span className="DocRating">
                        <img src={StarIcon} alt="" /> {allDetails?.averageRating}
                      </span>
                    </div>
                  </li>
                </ul>
                <div className="AppoDetails">
                  <h5>Your appointment in detail</h5>
                  <ul>
                    {appTimeDateAlreadySelected && (
                      <li>
                        {format(date, "MMMM d")} {selectedTime}
                      </li>
                    )}
                    <li>Choose the patient name</li>
                    {answers?.map((item, index) => (item?.skipped !== 1 ? <li key={index}>{item?.question}?</li> : null))}
                    {/* <li>Did you already visit this doctor?</li>
                    {chooseReason ? <li>What is the reason of the consultation?</li> : null} */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {selectedStep === questionDetails?.length + 2 ? (
          <div className="ContainerPnl">
            <div className="ColPnl-8">
              <div className="LftBox">
                <button
                  className="PrevBtn"
                  onClick={() => {
                    if (doctorSavedCunsultType === "1") {
                      setSelectedStep(questionDetails?.length + 1);
                    } else {
                      setSelectedStep(questionDetails?.length);
                    }
                  }}>
                  Go to back previous step
                </button>
                <h2>When are you the most comfortable?</h2>
                <div className="DateTimeWrapper">
                  <div className="LftDate">
                    <Calendar onChange={handleDateChange} value={date} minDate={new Date()} />
                  </div>
                  <div className="RhtTime">
                    <div className="DayDate">
                      <span>{format(date, "eeee")}</span>
                      <br />
                      {format(date, "MMMM d")}
                    </div>

                    {screenLoading ? (
                      <Skeleton count={2} height={20} width={"80%"} baseColor="#cfd5f9" />
                    ) : (
                      <ul>
                        {availDates?.length > 0 && !moment(date).isSameOrAfter(futureDate) ? (
                          availDates?.map((item, index) => {
                            const currentTime = moment().add(1, "hour");
                            const isToday = moment(date).isSame(currentTime, "day");
                            return (
                              // <li key={index} className={selectedTime === item ? "active" : ""} onClick={() => setSelectedTime(item)}>
                              item?.has_interval === 1 ? (
                                isToday ? (
                                  moment(item?.start_time, "HH:mm").isSameOrAfter(currentTime) ? (
                                    <li
                                      key={index}
                                      className={selectedTime === item?.start_time + "-" + item?.end_time ? "active" : ""}
                                      onClick={() => {
                                        const timeSlot = item?.start_time + "-" + item?.end_time;
                                        const count = getBookedCount(timeSlot);

                                        if (count < item?.visitor) {
                                          handleSelectTime(item);
                                        }
                                      }}
                                    >
                                      <span
                                        style={{
                                          backgroundColor: getBookedCount(item?.start_time + "-" + item?.end_time) >= item?.visitor ? "#616161" : "",
                                          cursor: getBookedCount(item?.start_time + "-" + item?.end_time) >= item?.visitor ? "not-allowed" : ""
                                        }}
                                      >
                                        {item?.start_time} to {item?.end_time}
                                      </span>
                                    </li>
                                  ) : null
                                ) : (
                                  <li
                                    key={index}
                                    className={selectedTime === item?.start_time + "-" + item?.end_time ? "active" : ""}
                                    onClick={() => {
                                      const timeSlot = item?.start_time + "-" + item?.end_time;
                                      const count = getBookedCount(timeSlot);

                                      if (count < item?.visitor) {
                                        handleSelectTime(item);
                                      }
                                    }}
                                  >
                                    <span
                                      style={{
                                        backgroundColor: getBookedCount(item?.start_time + "-" + item?.end_time) >= item?.visitor ? "#616161" : "",
                                        cursor: getBookedCount(item?.start_time + "-" + item?.end_time) >= item?.visitor ? "not-allowed" : ""
                                      }}
                                    >
                                      {item?.start_time} to {item?.end_time}
                                    </span>
                                  </li>
                                )
                              ) : (
                                generateTimeSlots(item?.start_time, item?.end_time, item?.intervals, item?.time_slot_type).map((timeItem, timeIndex) => {
                                  if (isToday) {
                                    if (moment(timeItem, "HH:mm").isSameOrAfter(currentTime)) {
                                      return (
                                        <li key={timeIndex} className={selectedTime === timeItem ? "active" : ""} onClick={() => !bookedAppoinment?.includes(timeItem) && handleSelectTime(timeItem)}>
                                          <span
                                            style={{
                                              backgroundColor: bookedAppoinment?.includes(timeItem) ? "#616161" : "",
                                              cursor: bookedAppoinment?.includes(timeItem) ? "not-allowed" : ""
                                            }}
                                          >{timeItem}</span>
                                        </li>
                                      );
                                    } else {
                                      return null;
                                    }
                                  } else {
                                    return (
                                      <li key={timeIndex} className={selectedTime === timeItem ? "active" : ""}
                                        onClick={() => !bookedAppoinment?.includes(timeItem) && handleSelectTime(timeItem)}
                                      //onClick={() => handleSelectTime(timeItem)}
                                      >
                                        {/* <span>{timeItem}</span> */}
                                        <span
                                          style={{
                                            backgroundColor: bookedAppoinment?.includes(timeItem) ? "#616161" : "",
                                            cursor: bookedAppoinment?.includes(timeItem) ? "not-allowed" : ""
                                          }}
                                        >{timeItem}</span>
                                      </li>
                                    );
                                  }
                                })
                              )
                            );
                          })
                        ) : (
                          <p>No times available for this day.</p>
                        )}
                      </ul>
                    )}
                  </div>
                </div>
                <p>
                  <button className="CmnBtn" onClick={() => handleChooseTimeCont()}>
                    Continue
                  </button>
                </p>
              </div>
            </div>
            <div className="ColPnl-4">
              <div className="RhtBox">
                <ul className="SearchedDoctors">
                  <li>
                    <div className="DocImg">
                      <img src={allDetails?.doctor?.profile_pic_url ? allDetails?.doctor?.profile_pic_url : DEFAULT_PROFILE_IMAGE} alt="" />
                    </div>
                    <div className="DocDtls">
                      <span className="DocName">
                        {allDetails?.doctor?.first_name} {allDetails?.doctor?.last_name}
                      </span>
                      <span className="DocType">{allDetails?.doctor?.speciality}</span>
                      <span className="DocRating">
                        <img src={StarIcon} alt="" /> {allDetails?.averageRating}
                      </span>
                    </div>
                  </li>
                </ul>
                <div className="AppoDetails">
                  <h5>Your appointment in detail</h5>
                  <ul>
                    {appTimeDateAlreadySelected && (
                      <li>
                        {format(date, "MMMM d")} {selectedTime}
                      </li>
                    )}
                    <li>Choose the patient name</li>
                    {answers?.map((item, index) => (item?.skipped !== 1 ? <li key={index}>{item?.question}?</li> : null))}
                    {/* {chooseReason ? <li>What is the reason of the consultation?</li> : null} */}
                    <li>Did you want to consultation via video or cabinet?</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {selectedStep === questionDetails?.length + 3 ? (
          <div className="ContainerPnl">
            <div className="ColPnl-8">
              <div className="LftBox">
                <button
                  className="PrevBtn"
                  onClick={() => (appTimeDateAlreadySelected ? setSelectedStep(questionDetails?.length + 1) : setSelectedStep(questionDetails?.length + 2))}>
                  Go to back previous step
                </button>
                <h2>Your appointment in detail</h2>
                <ul className="PatientList ConsultOption BookingDetails">
                  <li>
                    <span className="PatientName">
                      <img className="profilePic" src={allDetails?.doctor?.profile_pic_url ? allDetails?.doctor?.profile_pic_url : DEFAULT_PROFILE_IMAGE} alt="" />
                      <span className="NameWrapper">
                        Dr {allDetails?.doctor?.first_name} {allDetails?.doctor?.last_name}
                      </span>
                    </span>
                  </li>
                  <li>
                    <span className="PatientName">
                      <img src={CalanderIcon} alt="" />
                      <span className="NameWrapper">
                        {format(date, "MMMM d")} {selectedTime?.has_interval === 1 ? selectedTime?.start_time + "-" + selectedTime?.end_time : selectedTime}
                      </span>
                    </span>
                  </li>
                  <li>
                    <span className="PatientName">
                      <img src={LocIcon} alt="" />
                      <span className="NameWrapper">{allDetails?.doctor?.cabin_address}</span>
                    </span>
                  </li>
                  <li>
                    <span className="PatientName">
                      <img src={StethIcon} alt="" />
                      <span className="NameWrapper">{allDetails?.doctor?.speciality}</span>
                    </span>
                  </li>
                </ul>
                <p>
                  <button className="CmnBtn FullwidthBtn" onClick={() => handleConfirmAppointment()} disabled={addBtnDis}>
                    {addBtnDis ? "Please wait..." : "Confirm appointment"}
                  </button>
                </p>
                <p className="NotePara">By confirming this appointment, you agree to honour it.</p>
              </div>
            </div>
            <div className="ColPnl-4">
              <div className="RhtBox">
                <ul className="SearchedDoctors">
                  <li>
                    <div className="DocImg">
                      <img src={allDetails?.doctor?.profile_pic_url ? allDetails?.doctor?.profile_pic_url : DEFAULT_PROFILE_IMAGE} alt="" />
                    </div>
                    <div className="DocDtls">
                      <span className="DocName">
                        {allDetails?.doctor?.first_name} {allDetails?.doctor?.last_name}
                      </span>
                      <span className="DocType">{allDetails?.doctor?.speciality}</span>
                      <span className="DocRating">
                        <img src={StarIcon} alt="" /> {allDetails?.averageRating}
                      </span>
                    </div>
                  </li>
                </ul>
                <div className="AppoDetails">
                  <h5>Your appointment in detail</h5>
                  <ul>
                    <li>Choose the patient name</li>
                    {/* <li>Did you already visit this doctor?</li> */}
                    {answers?.map((item, index) => (item?.skipped !== 1 ? <li key={index}>{item?.question}?</li> : null))}
                    {/* {chooseReason ? <li>What is the reason of the consultation?</li> : null} */}
                    <li>Did you want to consultation via video or cabinet?</li>
                    <li>When are you the most comfortable?</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>

      {/* Add new member popup */}
      <Modal isOpen={modalIsOpen} onRequestClose={closeModal} contentLabel="">
        <img className="CloseModalBtn" src={CrossIcon} onClick={closeModal} alt="" />
        <h2>Add new member</h2>
        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever.</p>
        <ul className="AddNewMember">
          <li>
            <label>New member name</label>
            <input type="text" placeholder="Type here" value={patientForm.name} onChange={e => setPatientForm(prev => ({ ...prev, name: e.target.value }))} />
          </li>
          <li>
            <label>New member age</label>
            <input type="number" placeholder="Type here" value={patientForm.age} onChange={e => setPatientForm(prev => ({ ...prev, age: e.target.value }))} />
          </li>
          <li>
            <label>Relationship with you</label>
            <input
              type="text"
              placeholder="Type here"
              value={patientForm.relation}
              onChange={e => setPatientForm(prev => ({ ...prev, relation: e.target.value }))}
            />
          </li>
          <li>
            <button className="CmnBtn" type="button" onClick={() => handleAddPatient()} disabled={addBtnDis}>
              {addBtnDis ? "Please wait..." : "Add New"}
            </button>
          </li>
        </ul>
      </Modal>

      {showProfileModal && (
        <div className="popup holidayPopup AddAppointmentModal addMemberPopup" onClick={() => setShowProfileModal(false)}>
          <div className={`popup-content`} onClick={e => e.stopPropagation()}>
            <button
              onClick={() => {
                setShowProfileModal(false);
              }}
              className="cancelBtn">
              <img src={cancelIcon} alt="" />
            </button>
            <div className="addNursePopup addAppointment">
              <h2 className="nurseHdn">Add New Member</h2>
              <div className="patientAddBox">
                <ul className="addPatientList">
                  <li>
                    <div className="topSection">
                      <label className="label">This patient is a:</label>
                      <div className="radioWithLabel">
                        <div
                          className={`radioWithLabelInner ${addPatientObject?.membertype === "child" ? "active" : ""}`}
                          onClick={() => setAddPatientObject(prev => ({ ...prev, membertype: "child" }))}>
                          <input type="radio" name="membertype" checked={addPatientObject?.membertype === "child"} />
                          <label>Child</label>
                        </div>
                      </div>
                      <div className="radioWithLabel">
                        <div
                          className={`radioWithLabelInner ${addPatientObject?.membertype === "adult" ? "active" : ""}`}
                          onClick={() => setAddPatientObject(prev => ({ ...prev, membertype: "adult" }))}>
                          <input type="radio" name="membertype" checked={addPatientObject?.membertype === "adult"} />
                          <label>Adult</label>
                        </div>
                      </div>
                    </div>
                  </li>
                  {addPatientObject?.membertype === "child" || addPatientObject?.membertype === "adult" ? (
                    <>
                      {addPatientObject?.membertype === "child" ? (
                        <li>
                          <label>Relationship With You</label>
                          <select value={addPatientObject?.relation} onChange={e => setAddPatientObject(prev => ({ ...prev, relation: e.target.value }))}>
                            <option value="" disabled selected hidden>
                              Choose Relation
                            </option>
                            <option value={"mother"}>I AM HIS MOTHER</option>
                            <option value={"father"}>I AM HIS FATHER</option>
                            <option value={"family"}>FAMILY</option>
                          </select>
                        </li>
                      ) : null}

                      <li className="halfList">
                        <div className="radioWithLabel">
                          <div
                            className={`radioWithLabelInner ${addPatientObject?.gender === "male" ? "active" : ""}`}
                            onClick={() => setAddPatientObject(prev => ({ ...prev, gender: "male" }))}>
                            <input type="radio" name="childGender" checked={addPatientObject?.gender === "male"} />
                            <label>Male</label>
                          </div>
                        </div>
                      </li>
                      <li className="halfList">
                        <div className="radioWithLabel">
                          <div
                            className={`radioWithLabelInner ${addPatientObject?.gender === "female" ? "active" : ""}`}
                            onClick={() => setAddPatientObject(prev => ({ ...prev, gender: "female" }))}>
                            <input type="radio" name="childGender" checked={addPatientObject?.gender === "female"} />
                            <label>Female</label>
                          </div>
                        </div>
                      </li>
                      <li className="halfList">
                        <label>First Name</label>
                        <input
                          type="text"
                          placeholder={addPatientObject?.membertype === "child" ? `Child First Name (in French letters)` : `First Name (in French letters)`}
                          value={addPatientObject?.firstName}
                          onChange={e => setAddPatientObject(prev => ({ ...prev, firstName: e.target.value }))}
                        />
                      </li>
                      <li className="halfList">
                        <label>Last Name</label>
                        <input
                          type="text"
                          placeholder={addPatientObject?.membertype === "child" ? `Child Last Name (in French letters)` : `Last Name (in French letters)`}
                          value={addPatientObject?.lastName}
                          onChange={e => setAddPatientObject(prev => ({ ...prev, lastName: e.target.value }))}
                        />
                      </li>
                      <li className="dateOfBirthCont">
                        <label>Date of Birth</label>
                        <ul>
                          <li>
                            <select value={addPatientObject?.month} onChange={e => setAddPatientObject(prev => ({ ...prev, month: e.target.value }))}>
                              <option value="" disabled selected>
                                Month
                              </option>
                              {months?.map((item, index) => (
                                <option key={index} value={index + 1 < 10 ? "0" + (index + 1) : index + 1}>
                                  {item}
                                </option>
                              ))}
                            </select>
                          </li>
                          <li>
                            <select value={addPatientObject?.day} onChange={e => setAddPatientObject(prev => ({ ...prev, day: e.target.value }))}>
                              <option value="" disabled selected>
                                Day
                              </option>
                              {daysarray?.map((item, index) => (
                                <option key={index} value={item}>
                                  {item}
                                </option>
                              ))}
                            </select>
                          </li>
                          <li>
                            <select value={addPatientObject?.year} onChange={e => setAddPatientObject(prev => ({ ...prev, year: e.target.value }))}>
                              <option value="" disabled selected>
                                Year
                              </option>
                              {years?.map((year, index) => (
                                <option key={index} value={year}>
                                  {year}
                                </option>
                              ))}
                            </select>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <label>Birth City</label>
                        <select value={addPatientObject?.birthCity} onChange={e => setAddPatientObject(prev => ({ ...prev, birthCity: e.target.value }))}>
                          <option value="" disabled selected>
                            Select birth city
                          </option>
                          {cityList?.map((item, index) => (
                            <option key={index} value={item?.id}>
                              {item?.name}
                            </option>
                          ))}
                        </select>
                      </li>
                      <li>
                        <button disabled={addBtnDis} onClick={() => handleAddKid()}>
                          {addBtnDis ? "Please wait..." : "Add2"}
                        </button>
                      </li>
                    </>
                  ) : null}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookAppointment;
